export default "__VITE_ASSET__94cab866__"